import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { MyGlobal, MyAlert } from '../GlobalContext';
import Moment from 'react-moment';
import 'moment-timezone';
import { Link } from 'react-router-dom'

export class ResumeManifest extends Component {
    static displayName = ResumeManifest.name;

    constructor(props) {
        super(props);
        this.state = { loading: false, alertMessage: "", tempManifest: props.location.state, consignmentSummary:[] };
        this.history = props.history;

    }

    componentDidMount() {
        this.getTempManifestDetails();
    }
    goto(page) {
        this.history.push(page);
    }
    getTempManifestDetails() {
        this.setState({ loading: true, alertMessage: "" });

        fetch(`api/Manifest/GetTempManifestDetails?sessionId=${this.state.tempManifest.SessionId}`)
            .then(async response => {
                this.setState({ loading: false });
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    console.error(errorText);
                    this.setState({ alertMessage: "Failed to load Temporary Manifest Details !!" });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;
                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ consignmentSummary: data });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load Temporary Manifest Details !!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load Temporary Manifest Details !!" });
                    }
                }
            })
            .catch(error => {
                this.setState({ alertMessage: error });
            });
    }

    render() {

        const pagination = paginationFactory({
            page: 2,
            sizePerPage: 5,
            lastPageText: '>>',
            firstPageText: '<<',
            nextPageText: '>',
            prePageText: '<',
            showTotal: true,
            alwaysShowAllBtns: true
        });

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";


        const columns = [
            { dataField: 'docket', text: 'Docket' },
            { dataField: 'carrierReference', text: 'Carrier Reference' },
            { dataField: 'pallets', text: 'Pallets' },
            { dataField: 'cartons', text: 'Cartons' }
        ];


        return <div className="container" >
            {this.state.loading && <div> <em>Loading ... </em></div>}
            <br />

            <Container>
                <Row className="mb-3">
                    <Col xs={9}>
                        <h5>Consignment Summary</h5>
                        {alertMessage}
                    </Col>
                    <Col xs={3}>
                        <Link className="btn btn-success col-12 mb-2" to={{ pathname: "ManifestHistory" }}>Back</Link>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col xs={12}>
                        <Link className="btn btn-success col-12 mb-2" to={{
                            pathname: "CreateManifest",
                            state: {
                                ConsignmentSummary: this.state.consignmentSummary,
                                SelectedCarrierId: this.state.tempManifest.SelectedCarrierId,
                                SelectedCarrierName: this.state.tempManifest.SelectedCarrierName,
                                TempManifestSessionId: this.state.tempManifest.SessionId,
                            }
                        }}>Continue to Complete</Link>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col xs={12}>
                        <BootstrapTable keyField='docket' data={this.state.consignmentSummary} columns={columns} pagination={pagination} />
                    </Col>
                </Row>
            </Container>
            <br />
        </div>
    }


}
